<template>
		<section class="content">
			<div class="row">
				<div class="col-md-12">
					<div class="box box-primary">
						<div class="box-header with-border">
							<h3 class="box-title">
								<b>Simulador de venda com taxas</b>
							</h3>
						</div>
						<div class="box-body">
							<div class="row">
                  <div class="col-sm-5">
                    <div
                      :class="{'form-group': true, 'has-error':errors.has('qtd_parcelas') }"
                      style="text-align:left"
                    >
                      <label for="valor" style="font-size: 20px;">Valor da venda</label>
                      <money
											  ref="valor"
												class="form-control input"
												v-model="valor"
												v-bind="money"
											></money>
                      <span
                        v-show="errors.has('qtd_parcelas')"
                        class="help-block"
                      >É obrigatório informar o valor da venda</span>
                    </div>
                  </div>
									<div class="col-sm-5">
                    <div
                      :class="{'form-group': true, 'has-error':errors.has('qtd_parcelas') }"
                      style="text-align:left"
                    >
                      <label for="cpf" style="font-size: 20px;">Informe a quantidade de parcelas</label>
                      <select
                        class="form-control select"
                        name="qtd_parcelas"
                        v-model="qtd_parcelas"
                        v-validate="'required'"
                        ref="qtd_parcelas"
                      >
												<option :value="2">02</option>
												<option :value="3">03</option>
												<option :value="4">04</option>
												<option :value="5">05</option>
												<option :value="6">06</option>
												<option :value="7">07</option>
												<option :value="8">08</option>
												<option :value="9">09</option>
												<option :value="10">10</option>
												<option :value="11">11</option>
												<option :value="12">12</option>
											</select>
                      <span
                        v-show="errors.has('qtd_parcelas')"
                        class="help-block"
                      >É obrigatório informar a quantidade de parcelas</span>
                    </div>
                  </div>
									<div class="col-sm-2">
										<label style="font-size: 20px; color: #fff">Simulador</label>
										<button @click="simular" :disabled="valida" class="btn btn-primary form-control botao">SIMULAR</button>
									</div>
                </div>


								<div class="row" style="margin-top:15px" v-if="carregado">
									<div class="col-sm-12 table-responsive">
										Resultado da simulação de venda considerando taxa de antecipação e prorata.
										<table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
											<thead>
											<tr role="row">
												<th style="width: 33%">Parcela</th>
												<th style="width: 33%">Vencimento</th>
												<th style="width: 34%">Valor da parcela</th>
											</tr>
											</thead>
											<tbody>
											<tr class="even" role="row" v-for="(item, index) in apiData.boletos" :key="item.id">
												<td>{{ index + 1 }}</td>
												<td>{{ item.vencimento | dataFormatada }}</td>
												<td>{{ apiData.valor_nova_parcela | numberFormat(2, ',', '.') }}</td>
											</tr>
											<tr class="even" role="row" style="font-size: 18px">
												<td colspan="2" style="text-align: right">Total da Venda</td>
												<td>{{ apiData.total | numberFormat(2, ',', '.') }}</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div class="text-center" style="font-size: 30px" v-if="showMessage">Calculando...</div>
						</div>
					</div>
				</div>
			</div>
		</section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import { Money } from "v-money";

export default {

  data() {
		return {
			carregado: false,
			showMessage: false,
			money: {
				decimal: ",",
				thousands: ".",
				prefix: "R$ ",
				precision: 2,
				masked: false
			},

			valor: 0,
			qtd_parcelas: 2,

			apiData: {
				data: []
			}
		}
  },
	computed: {
		valida() {
			if (this.valor == '' || this.valor == 0) {
				return true;
			}

			if (this.qtd_parcelas == '' || this.qtd_parcelas == 0) {
				return true;
			}

			return false;

		}
	},

  methods: {
		simular() {
			this.carregado = false;
			this.showMessage = true;
			let config = this.$store.getters.getHeaderAuth;
				axios.get(`${this.$store.state.serverURI}/api/simulador/antecipacao/${this.valor}/${this.qtd_parcelas}`, config)
					.then(response => {
						this.carregado = true;
						this.showMessage = false;
						this.apiData = response.data;
					}).catch((error) => { this.$store.commit('throwException', error); });
		}
  },
  components: {
    Money
  }
};
</script>

<style scoped>
.input {
  font-size: 40px;
  text-align: left;
  padding: 30px;
}

.select {
    font-size: 40px;
    height: 62px;
		padding: 0px;
    padding-left: 30px;
}

.botao {
	font-size: 25px;
  text-align: center;
	height: 62px;
}

.solicitacao-dados {
  font-size: 20px;
  height: 40px;
  text-align: left;
  padding: 8px;
}
input {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// simuladorVenda.vue?611f64d3